import { useState } from "react";
import axios from "axios";
import { Lock, ArrowRight } from "lucide-react";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

const detailToMsg = (detail) =>
    Array.isArray(detail) ? detail.map((d) => d.msg).join(" · ") : typeof detail === "string" ? detail : "No se pudo iniciar sesión.";

export default function AdminLogin({ onLogin }) {
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);

    const submit = async (e) => {
        e.preventDefault();
        setLoading(true);
        setError("");
        try {
            const { data } = await axios.post(`${API}/auth/login`, { password });
            onLogin(data.token);
        } catch (err) {
            setError(detailToMsg(err?.response?.data?.detail));
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="flex min-h-screen items-center justify-center bg-navy px-6" data-testid="admin-login-page">
            <form onSubmit={submit} className="w-full max-w-sm border border-white/10 bg-navy-deep p-10" data-testid="admin-login-form">
                <span className="mb-8 flex h-11 w-11 items-center justify-center border border-gold/40 text-gold">
                    <Lock size={18} />
                </span>
                <p className="mb-2 text-[11px] uppercase tracking-[0.3em] text-gold">Panel privado</p>
                <h1 className="font-display text-3xl font-medium tracking-tight text-[#F8F9FA]">Acceso administrador</h1>
                <label htmlFor="admin-password" className="mb-2 mt-10 block text-[10px] uppercase tracking-[0.25em] text-[#9CA3AF]">
                    Contraseña
                </label>
                <input
                    id="admin-password"
                    type="password"
                    required
                    autoFocus
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    className="w-full border border-white/15 bg-transparent px-4 py-3.5 text-sm text-[#F8F9FA] transition-colors duration-300 focus:border-gold focus:outline-none"
                    data-testid="admin-password-input"
                />
                {error && (
                    <p className="mt-4 text-sm text-red-400" data-testid="admin-login-error">{error}</p>
                )}
                <button
                    type="submit"
                    disabled={loading}
                    className="group mt-8 flex w-full items-center justify-center gap-3 bg-gold px-8 py-4 text-[11px] font-semibold uppercase tracking-[0.22em] text-navy transition-colors duration-300 hover:bg-gold-soft disabled:opacity-60"
                    data-testid="admin-login-submit"
                >
                    {loading ? "Verificando…" : "Ingresar"}
                    {!loading && <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />}
                </button>
            </form>
        </div>
    );
}
